import $ from 'jquery'
import { CouchDBVectorSource } from 'ol-couchdb-source'
import VectorWFS from '../ol/source/VectorWFS'
import LantmaterietTopoWebb from '../ol/source/LantmaterietTopoWebb'
import { parseStyle } from '../styleParser'
import * as olControl from 'ol/control'
import * as olProj from 'ol/proj'
import View from 'ol/View'
import * as Layer from 'ol/layer'
import TileGrid from 'ol/tilegrid/TileGrid'
import WMTSTileGrid from 'ol/tilegrid/WMTS'
import { Vector as VectorSource } from 'ol/source'
import * as Source from 'ol/source'
import * as olFormat from 'ol/format'

/**
 * Configuration parser
 * @constructor
 */
export default function Parser() {}

/**
 * @param {Config} config
 * @return {Object} parsed layers, view and controls from config
 */
Parser.prototype.parse = function(config) {
  const layers = config.layers
  const parseLayer = this.parseLayer(config.defaultCors).bind(this)
  return {
    layers: layers.map(parseLayer),
    view: this.parseView(config.view, config.autoSearch),
    controls: olControl.defaults().extend([new olControl.ScaleLine()])
  }
}

/**
 * @param {Layer.Layer} layers
 * @return {Array<String>} visible layer names
 */
Parser.prototype.getLayerNames = function(layers) {
  return (
    layers
      .filter(layer => layer.visible === undefined || layer.visible === true)
      // TODO: sort by index before map
      .map(layer => layer.source.params.LAYERS)
  )
}

/**
 * @param {Layer.Layer} layers
 * @return {Array<String>} visible layer styles
 */
Parser.prototype.getStyleNames = function(layers) {
  return (
    layers
      .filter(layer => layer.visible === undefined || layer.visible === true)
      // TODO: sort by index before map
      .map(layer => layer.source.params.STYLES)
  )
}

/**
 * Parse projection
 * @param {Object} projection
 * @return {Object}
 */
Parser.prototype.parseProjection = function(projection) {
  if (projection) projection = olProj.get(projection)
  return projection
}

/**
 * Parse view
 * @param {Object} view
 * @return {View}
 */
Parser.prototype.parseView = function(view, checkAutoSearch) {
  if (view) {
    view.projection = this.parseProjection(view.projection)

    if (view.maxExtent) view.extent = view.maxExtent
    view = new View(view)
  }
  if (!checkAutoSearch && view.getCenter() == null) {
    view.setCenter([635050.48355, 7206572.95095])

    view.setZoom(2)
  }
  return view
}

/**
 * @param {Layer.Layer} layer
 * @return {Layer.Layer}
 */
Parser.prototype.parseLayer = function(defaultCors) {
  return function(layer) {
    layer.visible = layer.visible === undefined ? true : layer.visible
    const options = {}
    layer.source = Object.assign({crossOrigin: defaultCors || undefined}, layer.source)
    
    $.extend(options, layer || {})
    options.opacity = parseFloat(options.opacity)
    options.source = this.parseSource(layer.source, layer)
    options.style = parseStyle(layer.style)
    options.olga_ = layer
    delete options.metadata
    var mapLayer = new Layer[layer.type](options)
    layer.mapLayer_ = mapLayer
    return mapLayer
  }
}

/**
 * Parse source
 * @param {Object} source
 * @param {Object} layer
 * @return {Source.Source}
 */
Parser.prototype.parseSource = function(source, layer) {
  var options = $.extend(true, {}, source)
  const type = source.type
  delete options.type
  const data = source.data
  delete options.data

  options.format = this.parseFormat(options.format)
  options.loader = this.parseLoader(options.loader)
  options.strategy = this.parseStrategy(options.strategy)
  options.projection = this.parseProjection(options.projection)
  options.tileGrid = this.parseTileGrid(options.tileGrid)
  options.cacheSize = 128

  if (options.params && !options.params.VERSION)
    options.params.VERSION = '1.1.1'

  const olSource = (() => {
    switch (type) {
      case 'CouchDBVector':
        return CouchDBVectorSource(options.url, {
          dataProjection: options.dataProjection,
          fetch: options.fetch,
          replication:
            options.replication === undefined ? true : options.replication
        })
      case 'LMTopoWebb':
        return LantmaterietTopoWebb(options)
      case 'VectorWFS':
        return new VectorWFS(options)
      default:
        return new Source[type](options)
    }
  })()

  if (olSource instanceof VectorSource) {
    olSource.on('addfeature', e => e.feature.set('olga_', layer))
  }

  if (data) {
    // NOTE: hack to tag each static feature with config meta
    if (olSource instanceof VectorSource) {
      var features = options.format.readFeatures(data)
      olSource.addFeatures(features)
    }
  }

  return olSource
}

/**
 * Parse tilegrid
 * @param {Object} tileGrid
 * @return {TileGrid}
 */
Parser.prototype.parseTileGrid = function(tileGrid) {
  if (tileGrid) {
    const type = tileGrid.type
    switch (type) {
      case 'WMTS':
        tileGrid = new WMTSTileGrid(tileGrid)
        break
      case 'TileGrid':
        tileGrid = new TileGrid(tileGrid)
        break
      default:
        break
    }
    delete tileGrid.type
  }
  return tileGrid
}

/**
 * Parse format
 * @param {Object} format
 * @return {Object}
 */
Parser.prototype.parseFormat = function(format) {
  if (format) {
    const type = format.type
    delete format.type
    format = new olFormat[type]()
  }
  return format
}

/**
 * Parse strategy
 * @param {Object} strategy
 * @return {Object}
 */
Parser.prototype.parseStrategy = function(strategy) {
  // TODO: parse strategy meta
  // if (strategy) {
  // return ol.loadingstrategy.createTile(new ol.tilegrid.XYZ({maxZoom: 19}))
  // }
  return strategy
}

/**
 * Parse loader
 * @param {Object} loader
 * @return {Object}
 */
Parser.prototype.parseLoader = function(loader) {
  // if (loader) {
  //
  // }
  return loader
}
